import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

interface ColorItemProps {
  isSelected?: boolean;
}

export const ColorItem = styled(Box)<ColorItemProps>(({ isSelected }) => ({
  width: '32px',
  height: '32px',
  borderRadius: '8px', // Changed from circle to rounded square
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: '#fff',
  position: 'relative',
  transition: 'all 0.2s ease',
  boxShadow: isSelected
    ? '0 2px 8px rgba(0,0,0,0.2), 0 0 0 2px rgba(33, 150, 243, 0.3)'
    : '0 1px 3px rgba(0,0,0,0.1)',

  '&:hover': {
    transform: 'scale(1.1)',
    boxShadow: '0 2px 12px rgba(0,0,0,0.2)',
  },
}));

export const SelectedOverlay = styled(Box)(() => ({
  position: 'absolute',
  top: '2px',
  right: '2px',
  background: 'rgba(0,0,0,0.4)',
  borderRadius: '50%',
  width: '20px',
  height: '20px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
